import React, {useState, Fragment,} from 'react';
import { Card, CardContent,Typography, } from '@mui/material';
import {useDispatch} from 'react-redux';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import {obtenerRegistrosPersonalizadoPublic } from 'store/actions/customAction';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import { TablaPersonalizada } from 'components';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import ListadoDeMedios from './ListadoDeMedios';

const ListadoDeEmpresasPorCobertura = ({ openFullScreenDialog, handleClose, datosDelMedio, datosDeLasEmpresas}) => {
    const dispatch = useDispatch();

    const [responseData, setResponseData] = useState({ errorType: 'error', messageType: '', openResponse: false, });
    const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
    const [catalogoDeMediosPublicos] = useState("catalogoDeMediosPublicos");
    const [mostrarDetalleDeLaEmpresa, setMostrarDetalleDeLaEmpresa] = useState(false);
    const [listadoDeRegistrosDeMedios, setListadoDeRegistrosDeMedios] = useState([]);
    const {tipoDeMedioDeComunicacion, cobertura,  idRegistro} = datosDelMedio;

    const [encabezadoTabla] = useState([
      { title: 'Nit de la empresa', field: 'nit', cellStyle:{ maxWidth: '80px' }},
      { title: 'nombreEmpresa', field: 'nombreEmpresa', cellStyle:{ maxWidth: '80px' }},
      { title: 'nombreComercial', field: 'nombreComercial'},
      { title: 'propietario', field: 'propietario'},
      { title: 'telefono1', field: 'telefono1'},
      { title: 'telefono', field: 'telefono'},
      { title: 'tipoDeEmpresa', field: 'tipoDeEmpresa.descripcion'},
      { title: 'Acciones', field: 'accion',
      render: rowData=><div style={{minWidth: '100px'}}>
          {
              (<div>
                  <TooltipPersonalizado title="Ver medios de la empresa" handleFunction={() => mostrarMediosDeLaEmpresa(rowData)} icon={"visibility"} fontSize={30} />
              </div>)
          }
          </div>
      },
  ]);

  const mostrarMediosDeLaEmpresa = async (rowData) => {

    setcargandoSolicitud(true);
    ServiciosDelAPI[catalogoDeMediosPublicos].setearMetodoPublico(true);
    let respuesta = await dispatch(obtenerRegistrosPersonalizadoPublic({
        controller: catalogoDeMediosPublicos,
        saveInStore: false,
        nombreDelMetodo: `listar/registros/${rowData.nit}/${datosDelMedio.tipoDeMedioDeComunicacion.id}/${datosDelMedio.cobertura?.id || ""}` ,
    }));


    setcargandoSolicitud(false);
    if(respuesta?.error) return changeDataResponse('error', respuesta?.error?.message || 'No se pudó obtener los datos', true, );
    if(respuesta?.data?.length === 0) return changeDataResponse('error', respuesta?.error?.message || 'No existen datos para este medio', true, );
    if(!respuesta?.data) return changeDataResponse('error', respuesta?.error?.message || 'No existen datos para este medio', true, );

    setListadoDeRegistrosDeMedios(respuesta?.data)
    setMostrarDetalleDeLaEmpresa(true);
  }

  const cerrarModal = () => { setMostrarDetalleDeLaEmpresa(false); }

  const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (errorType, messageType, openResponse = false) => setResponseData({errorType,messageType,openResponse,});

    const { errorType, messageType, openResponse} = responseData;

    return (
      <DialogoPantallaCompleta
        openFullScreenDialog={openFullScreenDialog}
        handleClose={handleClose}
        title={"Empresas registradas"}
        fullscreen={true}
      >
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={errorType} content={messageType} open={openResponse} handClose={handClose}/>
            <Card>
                <Typography variant="h4" style={{textAlign: "center"}}>{tipoDeMedioDeComunicacion?.descripcion || ""} - {cobertura?.descripcion || ""} </Typography>
                <CardContent>
                <TablaPersonalizada
                      data={datosDeLasEmpresas || []}
                      title={"Listado de empresas registradas"}
                      header={encabezadoTabla}
                      addRegister={undefined}
                  />
                </CardContent>
            </Card>

            {mostrarDetalleDeLaEmpresa && (
              <ListadoDeMedios
                  openFullScreenDialog={mostrarDetalleDeLaEmpresa}
                  handleClose={cerrarModal}
                  title={"Detalle de la empresa"}
                  datosDelMedio={datosDelMedio}
                  datosDeLasEmpresas={datosDeLasEmpresas}
                  listadoDeRegistrosDeMedios={listadoDeRegistrosDeMedios}
              />
            )}
        </Fragment>
      </DialogoPantallaCompleta>
    );
}

export default ListadoDeEmpresasPorCobertura;